<template>
  <div id="app">
    <TopNavigation />
    <AppBody />
    <BrockFooter />
  </div>
</template>

<script>
import TopNavigation from './components/TopNavigation';
import BrockFooter from './components/BrockFooter';
import AppBody from './components/AppBody';

export default {
  name: 'App',
  components: {
    TopNavigation,
    BrockFooter,
    AppBody,
  },
};
</script>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css?family=Lato:300,400,700');
  @import './assets/_colors.scss';
  @import './assets/_globals.scss';

  #app {
    font-family: $font-family;
    font-size: $base-font-size;
    font-weight: $base-font-weight;
    color: $dark-grey;
    box-sizing: border-box;
  }

  img{
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue